import axios from 'axios';
export default class UpgleService {
    async getUpgleList(ad_type_id) {
        return await axios.post('api/v1/admin/ad-type/list', { ad_type_id: ad_type_id });
    }
    // async addNotice(title, description, create_date) {
    //     return await axios
    //         .post(`api/v1/admin/notice/add`, {
    //             title: title,
    //             description: description,
    //             create_date: create_dateā,
    //         })
    //         .then((res) => res);
    // }
    async viewUpgle(sub_type_id) {
        return await axios
            .post(`api/v1/admin/ad-type/details`, {
                sub_type_id: sub_type_id,
            })
            .then((res) => res.data.result);
    }
    async editUpgle(data) {
        return await axios
            .post(`api/v1/admin/ad-type/edit`, data)
            .then((res) => res);
    }
    async UpgleDetail(ad_type_cat) {
        return await axios
            .post(`api/v1/admin/ad-type/info/details`, {
                ad_type_cat: ad_type_cat,
            })  
            .then((res) => res.data.result);
            
    }
    async UpdateUpgle(data) {
        return await axios
            .post(`api/v1/admin/ad-type/info/edit`, data)
            .then((res) => res);
    }
}